<template>
  <section class="ctn">
    <heim-card>
      <header>
        <h1>{{ $t('login') }}</h1>
      </header>
      <form @submit.prevent="handleForm">
        <section>
          <main>
            <div class="row">
              <div class="inputs">
                <heim-input
                  type="email"
                  :label="$t('email')"
                  name="email"
                  placeholder="monithor@example.com"
                ></heim-input>
                <div class="input-password">
                  <heim-input
                    :type="type"
                    :label="$t('password')"
                    name="password"
                    v-model="password"
                    icon
                  >
                  </heim-input>
                  <heim-icon-button @click.native="e => {type=='password'? type = 'text': type = 'password'}">
                    <heim-icon :icon="type=='password'?'visibility-off':'visibility'"></heim-icon>
                  </heim-icon-button>
                </div>
              </div>
            </div>
          </main>
          <footer class="actions">
            <heim-button type="submit">{{ $t('login') }}</heim-button>
          </footer>
        </section>
      </form>
    </heim-card>
  </section>
</template>

<script>
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import { mapState } from "vuex";
export default {
  name: "Login",
  components: {
    HeimInput,
    HeimButton,
    HeimCard,
    HeimIconButton,
    HeimIcon
  },
  mounted() {
    this.$store.dispatch("setTitle", "Login");
  },
  data() {
    return {
      type: "password",
      password: ""
    };
  },
  computed: mapState(["toastOpened", "token"]),
  methods: {
    async handleForm(e) {
      await this.$store.dispatch("login", {
        email: e.target.email.value,
        password: e.target.password.value
      });
      if (this.token) return this.$router.push({ path: "/" });
    }
  }
};
</script>

<style scoped>
.input-password {
  position: relative;
}

.input-password .icon-button {
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 4px;
}

.input-password .icon-button:focus,
.input-password .icon-button:hover {
  box-shadow: none;
  color: var(--heim-secondary-color);
}
/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .paper-card {
    margin: 0 30%;
    min-width: 24rem;
  }
}
</style>
